import React from "react";
import { Zap, MailCheck, Check } from "lucide-react";
import { hero, trustItems } from "../mock";
import { Button } from "./ui/button";

const Hero = ({ onBuy }) => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative overflow-hidden bg-grid pt-36 pb-24">
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-yellow-400/10 rounded-full blur-3xl" />
      <div className="absolute top-40 right-0 w-96 h-96 bg-red-500/10 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-full pl-2 pr-5 py-2 animate-pulse-ring">
            <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
              <Zap className="w-4 h-4 fill-white" />
            </span>
            <span className="text-xs tracking-widest font-semibold">{hero.badge}</span>
          </div>

          <h1 className="font-pixel pixel-gold text-4xl sm:text-5xl lg:text-6xl leading-tight mt-7">
            {hero.title}
          </h1>

          <p className="text-slate-300 text-lg leading-relaxed mt-6 max-w-xl">
            {hero.description}
          </p>

          <ul className="mt-7 space-y-3">
            {hero.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3 text-slate-200">
                <span className="mt-1 w-5 h-5 rounded-full bg-yellow-400/15 border border-yellow-400/40 flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-yellow-400" />
                </span>
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-4 mt-9">
            <Button
              onClick={onBuy}
              className="bg-yellow-400 hover:bg-yellow-300 text-[#0a101e] font-semibold rounded-lg h-12 px-7 gap-2 text-base glow-yellow"
            >
              <Zap className="w-4 h-4 fill-[#0a101e]" /> Buy Now
            </Button>
            <Button
              onClick={() => scrollTo("faq")}
              variant="outline"
              className="bg-transparent border-yellow-400/50 hover:border-yellow-400 hover:bg-yellow-400/10 text-yellow-400 rounded-lg h-12 px-7 text-base"
            >
              How It Works
            </Button>
          </div>

          <div className="mt-8 flex items-center gap-3 bg-gradient-to-r from-green-600 to-green-500 text-white rounded-xl px-5 py-4 max-w-xl">
            <span className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center shrink-0">
              <MailCheck className="w-5 h-5" />
            </span>
            <span className="font-medium">{hero.banner}</span>
          </div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 mt-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {trustItems.map((t, i) => {
            const Icon = t.icon;
            return (
              <div
                key={i}
                className="flex flex-col items-center gap-2 bg-[#0f1a30]/60 border border-white/5 rounded-xl py-5 hover:border-yellow-400/40 transition-colors"
              >
                <Icon className="w-5 h-5 text-yellow-400" />
                <span className="text-xs text-slate-300 text-center px-2">{t.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
